import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { EngagementSVG } from '@common_components/svg/engagement.svg';

const EngagementIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <EngagementSVG/>
    </div>
  );
};

export { EngagementIcon };
